import { useMatchRoute, useParams, Outlet } from '@tanstack/react-router';
import { useUserPermissions } from '@anytag/auth';
import { Advertiser, useAdvertiserQuery, useAnalyticsSubscriptionPlanByAdvIdQuery } from '@anytag/graphql';
import { ButtonLink, RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AdvertiserTabs } from '@anytag/shared-organisms';
import { AdvertiserDetailsProvider } from './advertiser-details-context';

export const AdvertiserDetails = () => {
  const { hideAddUserBtn } = useUserPermissions();
  const params = useParams({ from: '/_private-routes/advertiser/$id' });
  const matchRoute = useMatchRoute();
  const matchDetailUsers = !!matchRoute({ to: '/advertiser/$id/users' });

  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { data, loading } = useAdvertiserQuery({
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    variables: { pk: Number(params.id) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/advertiser' });
    }
  });
  const { data: subscriptionData } = useAnalyticsSubscriptionPlanByAdvIdQuery({
    variables: { advId: Number(params.id) },
    errorPolicy: 'ignore' // When error, we set default option as No Plan subscribed
  });

  const advertiser = data?.advertiser;
  const subscription = subscriptionData?.analyticsSubscriptionPlanByAdvId || undefined;
  const hasAddUserLink = !hideAddUserBtn && matchDetailUsers;

  return (
    <div>
      <RenderDataWithFallback loading={loading} hasNoData={!advertiser}>
        <AdvertiserDetailsProvider values={{ advertiser: advertiser as Advertiser, subscription }}>
          <div data-card-connect-bottom>
            <Header>
              {hasAddUserLink ? (
                <ButtonLink
                  variant="solid"
                  to="/user/linked"
                  title={t('Button.Add User')}
                  className="ml-auto min-w-27 capitalize"
                  search={{ adv_id: String(params.id) }}
                  prefixIcon={{ icon: 'plus', size: '10px' }}
                />
              ) : null}
            </Header>
            <AdvertiserTabs advertiserId={Number(advertiser?.id)}></AdvertiserTabs>
          </div>
          <Outlet />
        </AdvertiserDetailsProvider>
      </RenderDataWithFallback>
    </div>
  );
};
